

































import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import BusinessRulesModule from "@/store/modules/business-rules";
import ApplicationModal from "@/components/global/ApplicationModal.vue";
import CreateGroupAndRule from "@/views/business-rules/components/CreateGroupAndRule.vue";
import GroupFacilityView from "@/views/business-rules/components/GroupFacilityView.vue";
import RuleEditorFooter from "@/views/business-rules/components/RuleEditorFooter.vue";
import RulesEngine from "@/views/business-rules/partials/RulesEngine.vue";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "RuleEditor",
  components: {
    ApplicationModal,
    CreateGroupAndRule,
    GroupFacilityView,
    RuleEditorFooter,
    RulesEngine
  }
})

export default class RuleEditor extends Vue {
  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @businessRules.Action("handleCurrentStep") public handleCurrentStep!: (step: number) => void;
  @businessRules.Action("handleGroupName") public handleGroupName!: (groupName: string) => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //
  get currentStep(): number {
    return this.businessRules.currentStep;
  }

  get footerFlow(): string {
    if (this.currentStep === 2) {
      return "group";
    } else if (this.currentStep === 4) {
      return "rules";
    }
    return "";
  }
  get displayFooter(): boolean {
    return this.currentStep === 2 || this.currentStep === 4;
  }
}

